module.exports = __webpack_public_path__ + "img/cg.753c3a11.svg";